// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M15 14V10H17V14H15Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M23 3H1V21H23V3ZM7 11H9V8H11V16H9V13H7V16H5V8H7V11ZM17 8C18.1046 8 19 8.89543 19 10V14C19 15.1046 18.1046 16 17 16H13V8H17Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-hd-filled')
export default class HdFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'hd-filled',
    }
  }
}
